import { RTKQueryTag } from 'src/common/constants';
import type { ApiResponse } from 'src/common/interfaces';
import type { CampaignDTO, CampaignUserMetrics, Hack2WinFlashSaleSchedule } from 'src/common/interfaces/campaigns';
import { apiSlice } from 'src/features/api/api-slice';

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCampaigns: builder.query<ApiResponse<CampaignDTO[]>, void>({
      query: () => ({
        url: 'campaigns',
        method: 'GET',
      }),
      providesTags: [RTKQueryTag.Campaigns],
      onQueryStarted(_, { dispatch, queryFulfilled }) {
        queryFulfilled
          .then(({ data: response }) => {
            if (response.status === 'success') {
              dispatch(apiSlice.util.invalidateTags([RTKQueryTag.Notifications]));
            }
          })
          .catch(() => {
            // eslint-disable-next-line no-console
            console.error('Failed to fetch campaigns');
          });
      },
    }),
    getCampaignUserMetrics: builder.query<ApiResponse<CampaignUserMetrics>, void>({
      query: () => ({
        url: 'campaigns/campaign-user-metrics',
        method: 'GET',
      }),
    }),
    getHack2winFlashSaleSchedule: builder.query<ApiResponse<Hack2WinFlashSaleSchedule>, void>({
      query: () => ({
        url: 'campaigns/hack2win-flash-sale-schedule',
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useGetCampaignsQuery,
  useGetCampaignUserMetricsQuery,
  useGetHack2winFlashSaleScheduleQuery,
  endpoints: campaignEndpoints,
} = extendedApiSlice;
